import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[monValidateCssSelector]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ValidateCssSelectorDirective, multi: true }],
    standalone: false,
})
export class ValidateCssSelectorDirective implements Validator {
    validate (control: AbstractControl): ValidationErrors | null {
        if (control.value === '') {
            return null;
        }

        try {
            document.querySelector(control.value);
            return null;
        } catch (err) {
            return { cssSelector: true };
        }
    }
}
